// polyfill for `[].at(0)`
import 'core-js/actual/array/at';

// Эта строка нужна, иначе плагин не подгружается вообще
export default defineNuxtPlugin(() => {});
